import { Keyboard, KeyboardAvoidingView, Platform, Pressable, StatusBar, View } from "react-native";
import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { updateData } from "../../../../services/Profile/profileService";
import styles from "../../styles/profileStyle";
import TopIconView from "../../../Auth/components/TopIconView";
import TextView from "../../../../components/CustomComponent/TextView";
import CustomComponent from "../../../../components/CustomComponent";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import BottomView from "../../../../components/GlobalComponents/BottomView";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import { handleBackButton } from "../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { Colors } from "../../../../globalStyles/ColorConfig";
import { SafeAreaView } from "react-native-safe-area-context";

const BasicInfo_Name = () => {
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("")

  const handleFirstNameChange = (text: string) => {
    setFirstname(text);
  };

  const handleLastNameChange = (text: string) => {
    setLastname(text)
  }

  const handleNextButton = async () => {
    const updateUser = {
      firstName: firstname,
      lastName: lastname,
      steps: 1,
    };
    await updateData(updateUser);
    navigation.navigate("date-of-birth" as never);
  };

  const validateName = () => {
    if (firstname.length && lastname.length) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "#ffffff",
        paddingTop: 30 
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={{ flex: 1 }}
      >
        <Pressable onPress={Keyboard.dismiss} style={{flex: 1}}>
          <View
            style={{
              flex: 1,
              paddingHorizontal: 25,
              gap: 16
            }}
          >
              <View style={{width:'100%',justifyContent:'center',alignItems:'center', flexDirection: 'row'}}>
                <TopIconView
                  icon={<OnBoardingIcons.NameIcon />}
                  currentScreen={1}
                  totalScreens={10}
                />
              </View>
              <View style={styles.middleScreen}>
                <TextView
                  title="What's your name?"
                  textStyle={[
                    GlobalStyles.heading3,
                    {
                      fontFamily: "EBGaramondSemiBold",
                      fontSize: 34,
                      lineHeight: 37,
                      letterSpacing: -0.3,
                    },
                  ]}
                />
                <View style={{ marginTop: 23, height: 48, width: '100%' }}>
                  <CustomComponent.InputField
                    placeholder="First name"
                    keyboardtype="default"
                    onTextChange={handleFirstNameChange}
                    InputStyle={{fontSize: 16}}
                  />
                </View>
                <View style={{ marginTop: 23, height: 48, width: '100%' }}>
                  <CustomComponent.InputField
                    placeholder="Last name"
                    keyboardtype="default"
                    onTextChange={handleLastNameChange}
                    InputStyle={{fontSize: 16}}
                  />
                </View>
                {/* <View style={styles.innerBottom}>
                  <OnBoardingIcons.EyeIcon />
                  <TextView
                    title="Always visible on Profile"
                    textStyle={[
                      GlobalStyles.bodyText,
                      {
                        color: "#6E6E6E",
                        opacity: 0.6,
                        fontSize: 16,
                        fontFamily: "InterMedium",
                        lineHeight: 20,
                        letterSpacing: -0.3,
                      },
                    ]}
                  />
                </View> */}
              </View>
          </View>
          <BottomView
            enableTitle={false}
            onPress={handleNextButton}
            disableBtn={validateName()}
            style={{paddingBottom: 20}}
          />
        </Pressable>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

export default BasicInfo_Name;
